<template>
  <slot v-if="!error"></slot>
  <SoAlert v-else type="error" title="Failed to render content"> </SoAlert>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoAlert from "@/components/SoAlert.vue"

  export default defineComponent({
    components: {
      SoAlert,
    },
    props: {
      asyncError: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        err: false,
      }
    },
    computed: {
      error() {
        return this.err || this.asyncError
      },
    },

    errorCaptured() {
      this.err = true
    },
  })
</script>
